/* eslint-disable */
import React , { Component } from 'react';

import classes from './ConfigBannedItem.css';

class ConfigBannedItem extends Component {
    render () {
        return (
            <div>
                <p>{this.props.id}</p>
            </div>
        );
    }
}

export default ConfigBannedItem;